export const combobox = {
  namespaced: true,
  state: {
    type: undefined,
    selected: {
      additional: {
        total_attendance: false,
        date: undefined,
        page: 1
      }
    }
  },
  actions: {
    store_selected ({ commit }, message) {
      if (message.type === 'company') {
        commit('getCompanyState', message)
      } else if (message.type === 'partial-supervisor') {
        commit('getPartialState', message)
      } else {
        commit('getSupervisorState', message)
      }
    },
    clear_selected ({ commit }, message) {
      commit('clear')
    }
  },
  mutations: {
    getCompanyState (state, message) {
      state.type = message.type
      state.selected = {
        user: message.data.user,
        unit: message.data.unit,
        additional: {
          total_attendance: false,
          ...(message.minified) && { minified: true },
          date: message.data.additional.date,
          page: 1
        }
      }
    },
    getSupervisorState (state, message) {
      state.type = message.type
      state.selected = {
        user: message.data.user,
        area: message.data.area,
        district: message.data.district,
        unit: message.data.unit,
        company: message.data.company,
        additional: {
          ...(message.minified) && { minified: true },
          date: message.data.additional.date,
          page: 1
        }
      }
    },
    getPartialState (state, message) {
      state.type = message.type
      state.selected = {
        user: message.data.user,
        unit: message.data.unit,
        company: message.data.company,
        additional: {
          ...(message.minified) && { minified: true },
          date: message.data.additional.date,
          page: 1
        }
      }
    },
    clear (state, message) {
      state.selected = {
        user: undefined,
        area: undefined,
        district: undefined,
        unit: undefined,
        company: undefined,
        additional: {
          date: undefined,
          page: 1
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/selected-cbx.module.js